/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Credit limit change request
 */
export interface CreditLimitChangeRequestV2 {
  accountId: number;
  assetId?: number;
  credit?: number;
}
